"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defaultProps = _interopRequireDefault(require("recompose/defaultProps.js"));
var _react = _interopRequireDefault(require("react"));
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _About = _interopRequireDefault(require("../../pages/About"));
var _Laravel = _interopRequireDefault(require("../../pages/Laravel"));
var _Logs = _interopRequireDefault(require("../../pages/Logs"));
var _cccisdLaravelTags = _interopRequireDefault(require("cccisd-laravel-tags"));
var _cccisdLaravelShortUrls = require("cccisd-laravel-short-urls");
var _cccisdLaravelAssignment = require("cccisd-laravel-assignment");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdLaravelLicensing = require("cccisd-laravel-licensing");
var _Root = _interopRequireDefault(require("../../Root.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Fortress = window.cccisd.fortress;

/*
 * To use, include the following line within the <Switch> in your routes.js
 * (where MainLayout is the layout you want used for each of the admin routes):
 *
 * {AdminRoutes(MainLayout)}
 */
var _default = exports["default"] = function _default(Layout) {
  var AdminRoute = (0, _defaultProps["default"])({
    layout: Layout
  })(_cccisdLaravelBoilerplate.Route);
  var routes = [];
  if (Fortress.hasAccess('appdefs.debug')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "About",
      path: "/appdefs/about",
      component: _About["default"]
    }));
  }
  if (Fortress.hasAccess('appdefs.debug')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Laravel",
      path: "/appdefs/laravel",
      component: _Laravel["default"]
    }));
  }
  if (Fortress.hasAccess('appdefs.logs')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Logs",
      path: "/appdefs/logs",
      component: _Logs["default"]
    }));
  }
  if (Fortress.hasAnyAccess(['quest.admin', 'quest.code', 'quest.deploy', 'quest.design', 'quest.export', 'quest.permissions', 'quest.status', 'quest.view_data'], 'anyTarget') || Fortress.settings.role === 'questprojectadmin') {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Quest",
      path: "/quest",
      component: _cccisdLaravelAssignment.Quest
    }));
  }
  if (Fortress.hasAccess('poly.admin')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Tags",
      path: "/tags",
      component: _cccisdLaravelTags["default"]
    }));
  }
  if (Fortress.hasAccess('resources.admin')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Resources",
      path: "/resources",
      component: _cccisdLaravelResources.ResourceManager
    }));
  }
  if (Fortress.hasAccess('appdefs.admin')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "AppDefs",
      path: "/appdefs",
      component: _Root["default"]
    }));
  }
  if (Fortress.hasAccess('shorturls.admin')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "AppDefs",
      path: "/shorturls",
      component: _cccisdLaravelShortUrls.ShortUrls
    }));
  }
  if (Fortress.hasAccess('licensing.admin')) {
    routes.push( /*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "LicensedProducts",
      path: "/licensed-products",
      component: _cccisdLaravelLicensing.ProductManage
    }));
  }
  return routes;
};